import React from 'react';
import { stylesToString } from './InlineStyles.utils.mjs';

function InlineStyles({ selector, styles, media }) {
  return /* @__PURE__ */ React.createElement(
    "style",
    {
      "data-kohler-styles": "inline",
      dangerouslySetInnerHTML: {
        __html: stylesToString({ selector, styles, media })
      }
    }
  );
}

export { InlineStyles };
